import React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import Date from "@ui-kit/format/date";

interface IProps {
  from: AbstractDate;
  to: AbstractDate;
  locale: Locale;
  timezone: Timezone;
  nowDate?: AbstractDate;
}

const RadarlyComponentsCardsCardSubtitle = ({
  from,
  to,
  locale,
  timezone,
  nowDate,
}: IProps) => (
  <Date
    locale={locale}
    timezone={timezone}
    from={from}
    to={to}
    nowDate={nowDate}
  />
);

export default RadarlyComponentsCardsCardSubtitle;
